import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withData } from '../utility/DataContext';
import Dialog from '@material-ui/core/Dialog';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import dateFormat from 'dateformat';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';


const styles = theme => ({
  card: {
    width: '100%',
  },
  head: {
    display: 'flex',
  },
  content: {
    width: '60%'
  },
  cover: {
    width: '40%',
    height: 160,
    objectPosition: 'center',
    objectFit: 'cover'
  },
  loading: {
    width: '40%',
    height: 160
  },
  text: {
    marginTop: 30
  },
  expanded: {
    marginTop: 0,
  },
  expandDetail: {
    backgroundColor: theme.palette.divider,
    padding: 0,
    maxHeight: 250,
    overflow: 'auto'
  }
});


class MemeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      imageLoaded: false,
      logs: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.template === null) return;
    if (this.props.template !== prevProps.template){
      this.active();
      if (this.props.template.usedBy.length > 0){
        this.setState({logs: []}, this.getLogs);
      }
    }
  }

  active = () => {
    this.setState({
      open: true,
      imageLoaded: false,
      logLoaded: false
    });
  };

  handleClose = () => {
    this.setState({open: false});
  };

  getLogs = () => {
    this.props.template.usedBy.forEach((id, index) => {
      this.props.data.firestore.collection('memes').doc(id).get().then(doc => {
        let data = doc.data();
        data.id = doc.id;
        data.order = index;
        this.setState(prevState => {
          return {logs: [...prevState.logs, data]};
        });
      });
    });
  }

  render() {
    const {template, classes} = this.props;

    if (!template) return null;

    const dateTime = new Date(template.date);

    return (
      <Dialog open={this.state.open} onClose={this.handleClose} maxWidth={false} className={classes.dialog}>
        <Card className={classes.card}>
          <div className={classes.head}>
            <CardContent className={classes.content}>
              <Typography variant="headline">{template.name}</Typography>
              <Typography variant="caption" color="textSecondary">
                {dateFormat(dateTime, 'yyyy m/d H:MM')}
              </Typography>
              <Typography variant="subheading" color="textSecondary" classes={{root: classes.text}}>
                使用次數: {template.count}
              </Typography>
            </CardContent>
            {!this.state.imageLoaded &&
              <Grid container justify="center" alignItems="center" className={classes.loading}>
                <CircularProgress color="primary" size={80} thickness={1.5} />
              </Grid>
            }
            <img
              className={classes.cover}
              src={template.url}
              onLoad={()=>this.setState({imageLoaded: true})}
              alt='profile'
              style={{display: this.state.imageLoaded ? 'block' : 'none'}}
            />
          </div>
          {template.usedBy.length > 0 &&
            <ExpansionPanel classes={{expanded: classes.expanded}}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>紀錄</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails classes={{root: classes.expandDetail}}>
                <List className={classes.root}>
                  {this.state.logs
                    .sort((a, b) => {
                      return b.order - a.order
                    })
                    .map(meme => (
                      <ListItem key={`item-${meme.id}`}>
                        <ListItemText primary={meme.content.split(' ').join(' / ')} />
                      </ListItem>
                  ))}
                </List>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          }
        </Card>
      </Dialog>
    );
  }
}


export default withStyles(styles)(withData(MemeDetail));


// WEBPACK FOOTER //
// ./src/components/MemeDetail.js